module.exports = __webpack_public_path__ + "img/zh.425a6d64.png";